const React = require("react");
const {LINK_ADMIN_ROOT} = require("../../../../../../constants/links");
const {Link} = require("../../../../../../router");
const AppIcon = require("../../../../../icons/Lunu");
const AppIconCompact = require("../../../../../icons/LunuCompact");

module.exports = ({compactView, insideHiddenMenu}) => (
  <div className="h140 h80@m layoutRow fhaS fvaC">
    <Link
      className={
        `layoutRow fhaS fvaC tdN olN dn o70:h rlv
        (w|fhaC).compact`
        + (compactView ? ' compact' : '')
      }
      href={LINK_ADMIN_ROOT}
    >
      {compactView
        ? (
          <AppIconCompact className="w14 rlv cF" />
        ) : (
          <>
            <AppIcon className={
                `w128 mr20 rlv cF c0@m cF.insideHiddenMenu@m`
                + (insideHiddenMenu ? ' insideHiddenMenu' : '')
              }
            />
            {!insideHiddenMenu && (
              <div className="rlv">
                <div className="abs svl layoutRow fhaC fvaC">
                  <div
                    className="cA3A7AC fw3 f16 lh30 lts0em c0@m"
                  >Admin</div>
                </div>
              </div>
            )}
          </>
        )
      }
    </Link>
  </div>
);
